import React, { useEffect, useState } from "react";
import ChipButton from "../ChipButton/ChipButton";
import { ManualLoadingInfiniteScrollerType } from "./ManualLoadingInfinitScroller.types";

export function ManualLoadingInfiniteScroller({
    infiniteRef,
    loadMore,
    showLoadMoreButton = false,
    isInitLoadingDone,
    isLoading = false,
    hasNextPage,
    loadingMoreButtonText = "Alle anzeigen",
    loadMoreMargin,
    autoLoadDataAfterClick = true,
    errorHappened = false,
}: ManualLoadingInfiniteScrollerType) {
    function handleClick() {
        loadMore();
        setIsLoadMoreButtonClicked(true);
    }

    const [hasMoreData, setHasMoreData] = useState(false);
    const [isLoadMoreButtonClicked, setIsLoadMoreButtonClicked] =
        useState(false);

    useEffect(() => {
        if (isInitLoadingDone) {
            setHasMoreData(hasNextPage);
        }
    }, [isInitLoadingDone]);

    const autoLoadDataAfterButtonIsClicked =
        !autoLoadDataAfterClick ||
        (autoLoadDataAfterClick && !isLoadMoreButtonClicked);

    if (
        showLoadMoreButton &&
        isInitLoadingDone &&
        !isLoading &&
        hasMoreData &&
        autoLoadDataAfterButtonIsClicked &&
        !errorHappened
    ) {
        return (
            <ChipButton
                label={loadingMoreButtonText}
                onClick={handleClick}
                sx={{ margin: loadMoreMargin }}
            />
        );
    } else {
        return <div style={{ height: "1px" }} ref={infiniteRef} />;
    }
}
